import {
    NavItem,
    NavLink
} from "reactstrap";

import ImageWrapper from "@components/ui-components/image-wrapper";
import { Link } from "react-router-dom";
import { PanelDefaultRoute } from "@src/router/routes";
import {
    PanelUserDropdown
} from "@components/navbar-common";
import { handleMenuCollapsed } from "@helpers/utils";
import themeConfig from "@configs/theme-config";

const Navbar = props => {
    // ** Props
    const { setMenuVisibility, menuHidden, menuCollapsed } = props;
    const {
        app: { logo }
    } = themeConfig;

    return (
        <>
            {menuHidden && (
                <NavLink to={PanelDefaultRoute} className="navbar-brand" tag={Link}>
                    <span className="nav-brand-logo w-100">
                        <ImageWrapper
                            src={logo}
                            alt="logo"
                            id="brand-logo"/>
                    </span>
                </NavLink>
            )}
            {!menuHidden &&  <i
                className={`mdi mdi-${
                    menuCollapsed ? "chevron-right" : "chevron-left"
                } cursor-pointer text-dark font-medium-3 d-none d-xl-block nav-menu-icon`}
                onClick={() => handleMenuCollapsed()}/>} 
            <div className="d-flex align-items-center">
                <ul className="navbar-nav d-xl-none">
                    {!menuHidden && (
                        <NavItem className="mobile-menu me-auto">
                            <NavLink
                                className="nav-menu-main menu-toggle hidden-md is-active"
                                onClick={() => setMenuVisibility(true)}>
                                <i className="icon mdi mdi-menu" />
                            </NavLink>
                        </NavItem>
                    )}
                </ul>
            </div>

            <ul className="nav navbar-nav align-items-center ms-auto">
                <PanelUserDropdown/>
            </ul>
        </>
    );
};

export default Navbar;
